import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {usePopupEditTasksContext} from './PopupEditTasksContext';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import TaskGeneral from './TaskGeneral';
import TaskVisit from './TaskVisit';
import {can} from '../../../_common/components/Permissions';
import {taskTypeIDs} from '../../../_common/constants/taskTypes';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';

const PopupEditTask = ({id, type}) => {
  const {getData, edit, formik} = usePopupEditTasksContext();
  const {isValid, dirty} = formik;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = async () => {
    setShow(true);
    await getData(id);
  };
  const handleEdit = async () => {
    await edit();
    handleClose();
  };
  const intl = useIntl();
  const header = intl.formatMessage({
      id: 'tab-order-inspections-tasks-button-label-editTask',
      defaultMessage: `Edit task ${id}`
    }, {id}
  );

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'primary'}
        title={TTS.EDIT_TASK}
        onClick={handleShow}
        disabled={!can(T.FULL, S.TASKS_PAGE)}
        label={<img src={'../../../media/common/Edit_primary.svg'} alt="edit"/>}
        customClassnames={'mx-2'}
      />
      <ModalContainer show={show} onHide={handleClose} size={'md'}>
        {(type === taskTypeIDs.general)
          ? <TaskGeneral header={header}/>
          : <TaskVisit header={header}/>
        }
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            label={intl.formatMessage({id: 'tab-order-inspections-tasks-button-close', defaultMessage: 'Close'})}
            onClick={handleClose}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={intl.formatMessage({id: 'tab-order-inspections-tasks-button-submit', defaultMessage: 'Submit'})}
            onClick={() => handleEdit()}
            disabled={!(isValid && dirty)}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupEditTask;
